import { useEffect, useState } from "react";
import { animated, useTransition } from "@react-spring/web";

import Slider from "src/components/slider";
import Button from "src/components/button";

import { Account } from "src/types/accounts";

import styles from './styles.module.scss';
import _ from "lodash";
import cx from "classnames";

interface LiveConfirmationDialogProps {
  show: boolean;
  collection?: any;
  onClose: () => void;
  onSave?: (updated: Partial<Account>) => void;
}

const LiveConfirmationDialog: React.FC<LiveConfirmationDialogProps> = ({
  show,
  collection,
  onClose,
  onSave,
}) => {
  const [live, setLive] = useState(_.get(collection, "live", false));

  useEffect(() => {
    setLive(_.get(collection, "live", false));
  }, [collection, show]);

  const transition = useTransition(show, {
    initial: { opacity: 1, transform: "translateX(0%)" },
    from: { opacity: 0, transform: "translateX(-100%)" },
    enter: { opacity: 1, transform: "translateX(0%)" },
    leave: { opacity: 0, transform: "translateX(-100%)" },
    config: { tension: 220, friction: 28 },
  });

  const handleSave = () => {
    const updatedLive = !live;
    setLive(updatedLive);

    if (collection) {
      onSave?.({
        ...collection,
        live: updatedLive,
      });
    }
    onClose();
  };

  const handleCancel = () => {
    setLive(_.get(collection, "live", false));
    onClose();
  };

  return (
    <>
      {transition(
        (stylesAnim, item) =>
          item && (
            <Slider.Dialog
              show={show}
              onClose={handleCancel}
              className={cx(styles.confrimationDialog, styles.live)}
              width="400px"
            >
              <animated.div style={stylesAnim} className={styles.liveContainer}>
                <Slider.Body className={styles.body}>
                  <div className={styles.header}>
                    <h2 className={styles.title}>
                      {live ? <>turn OFF<br />live collection</> : <>turn ON<br />live collection</>}
                    </h2>
                  </div>

                  {live && (
                    <p className={styles.message}>
                      Turning this feature OFF will stop syncing any further changes to this collection for recipients you may have shared with.
                    </p>
                  )}
                  {!live && (
                    <p className={styles.message}>
                      Enable this setting to keep all collections in your account live and updated, even after they’re shared with recipients.
                    </p>
                  )}

                </Slider.Body>
              </animated.div>
              <Slider.Actions>
                <Button variant="primary"
                  icon="paperflite-tick"
                  text="Confirm"
                  onClick={handleSave} />
                <Button text="Cancel" onClick={onClose} />
              </Slider.Actions>
            </Slider.Dialog>
          )
      )}
    </>
  );
};

export default LiveConfirmationDialog;
